import {
  Box,
  useTheme,
  useMediaQuery,
  Link,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RouteUrls } from "../../Constants/RouteUrls";
import { Fragment, useEffect, useState, useRef } from "react";
import { OtpMethodDataArr, PasswordMethodDataArr } from "./Data";
import authApi from "Service/Auth.api";
import { useDispatch } from "react-redux";
import { setMyInfo } from "../../Redux/User/Action";
import { FormateMyInfoData } from "./Formatter";
import {
  setAlertData,
  startLoading,
  stopLoading,
} from "../../Redux/Screen/Action";
import OtpInput from "Components/OtpInput";
import "./LoginModern.css";

const LoginPage = () => {
  const [formData, setFormData] = useState(PasswordMethodDataArr);
  const [loginMethod, setLoginMethod] = useState("password");
  const [otpSent, setOtpSent] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:820px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const canvasRef = useRef(null);
  const panelRef = useRef(null);
  const [searchParams] = useSearchParams();

  // 2FA States
  const [is2FA, setIs2FA] = useState(false);
  const [maskedPhone, setMaskedPhone] = useState("");
  const [tempUserData, setTempUserData] = useState(null);
  const [otpValue, setOtpValue] = useState("");

  // Timer & Counters
  const [timer, setTimer] = useState(0);
  const timerInterval = useRef(null);
  const [liveCount, setLiveCount] = useState(124);
  const [activityText, setActivityText] = useState("Arjun from Pune just filed a Legal Notice");
  const [activityOpacity, setActivityOpacity] = useState(1);

  // Typewriter Headline State
  const [typedHeadline, setTypedHeadline] = useState("Legal help at\nyour fingertips.");

  // ═══════════════════════════════════════
  // REFINED PARTICLE ENGINE (WITH MOUSE)
  // ═══════════════════════════════════════
  useEffect(() => {
    if (!canvasRef.current || isMobile) return;
    const cvs = canvasRef.current;
    const ctx = cvs.getContext("2d");
    let W, H, pts = [];
    const mouse = { x: -999, y: -999 };

    const resize = () => {
      W = cvs.width = cvs.offsetWidth;
      H = cvs.height = cvs.offsetHeight;
    };

    const handleMouseMove = (e) => {
      const r = cvs.getBoundingClientRect();
      mouse.x = e.clientX - r.left;
      mouse.y = e.clientY - r.top;
    };

    const setup = () => {
      resize();
      pts = [];
      for (let i = 0; i < 72; i++) {
        pts.push({
          x: Math.random() * W,
          y: Math.random() * H,
          vx: (Math.random() - 0.5) * 0.38,
          vy: (Math.random() - 0.5) * 0.38,
          r: Math.random() * 1.6 + 0.5,
          op: Math.random() * 0.45 + 0.08,
          col: Math.random() > 0.7 ? [240, 180, 41] : Math.random() > 0.5 ? [255, 255, 255] : [15, 157, 88]
        });
      }
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      const len = pts.length;
      for (let i = 0; i < len; i++) {
        const p = pts[i];
        for (let j = i + 1; j < len; j++) {
          const q = pts[j];
          const dx = p.x - q.x, dy = p.y - q.y;
          const d = Math.sqrt(dx * dx + dy * dy);
          if (d < 130) {
            let alp = (1 - d / 130) * 0.22;
            const mx = p.x - mouse.x, my = p.y - mouse.y;
            const md = Math.sqrt(mx * mx + my * my);
            if (md < 160) alp += 0.18 * (1 - md / 160);
            ctx.beginPath();
            ctx.strokeStyle = `rgba(240,180,41,${alp})`;
            ctx.lineWidth = 0.6;
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(q.x, q.y);
            ctx.stroke();
          }
        }
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${p.col[0]},${p.col[1]},${p.col[2]},${p.op})`;
        ctx.fill();

        p.x += p.vx; p.y += p.vy;
        if (p.x < -20 || p.x > W + 20) p.vx *= -1;
        if (p.y < -20 || p.y > H + 20) p.vy *= -1;

        const dmx = p.x - mouse.x, dmy = p.y - mouse.y;
        const dm = Math.sqrt(dmx * dmx + dmy * dmy);
        if (dm < 80) {
          const f = (1 - dm / 80) * 0.3;
          p.vx += dmx / dm * f; p.vy += dmy / dm * f;
        }
        const spd = Math.sqrt(p.vx * p.vx + p.vy * p.vy);
        if (spd > 1.2) { p.vx = p.vx / spd * 1.2; p.vy = p.vy / spd * 1.2; }
      }
      requestAnimationFrame(draw);
    };

    setup();
    draw();
    window.addEventListener("resize", resize);
    cvs.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("resize", resize);
      cvs.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isMobile]);

  // ═══════════════════════════════════════
  // TYPEWRITER HEADLINE LOGIC
  // ═══════════════════════════════════════
  useEffect(() => {
    const lines = [
      'Legal help at\nyour fingertips.',
      'GST filing,\nsimplified.',
      'Justice for\nevery Indian.',
      'Your compliance,\nhandled.',
      'Expert counsel,\nonline.',
      'Contracts. Cases.\nCompliance.'
    ];
    let li = 0, ci = 0, del = false;
    let timeout;

    const tick = () => {
      const cur = lines[li];
      if (!del && ci < cur.length) {
        setTypedHeadline(cur.substring(0, ci + 1));
        ci++;
        timeout = setTimeout(tick, ci === 1 ? 300 : 55);
      } else if (!del && ci === cur.length) {
        del = true;
        timeout = setTimeout(tick, 2400);
      } else if (del && ci > 0) {
        setTypedHeadline(cur.substring(0, ci - 1));
        ci--;
        timeout = setTimeout(tick, 32);
      } else {
        del = false;
        li = (li + 1) % lines.length;
        timeout = setTimeout(tick, 260);
      }
    };

    tick();
    return () => clearTimeout(timeout);
  }, []);

  // ═══════════════════════════════════════
  // LIVE COUNT & ACTIVITY TICKER
  // ═══════════════════════════════════════
  useEffect(() => {
    const countInterval = setInterval(() => {
      setLiveCount(prev => {
        let n = prev + Math.floor(Math.random() * 3) - 1;
        if (n < 120) n = 120; if (n > 140) n = 140;
        return n;
      });
    }, 3500);

    const acts = [
      'Arjun from Pune just filed a Legal Notice',
      'Priya from Delhi connected with a CA',
      'Ravi from Mumbai got his contract drafted',
      'Sunita from Jaipur filed GST returns on time',
      'Karan from Hyderabad completed company registration',
      'Meera from Chennai resolved a tenant dispute via ODR',
      'Suresh from Ahmedabad filed an ITR successfully',
      'Anita from Kolkata registered her trademark',
      'Vikram from Bengaluru got DPDP compliance done',
      'Fatima from Lucknow filed a consumer complaint'
    ];
    let idx = 0;
    const tickerInterval = setInterval(() => {
      setActivityOpacity(0);
      setTimeout(() => {
        idx = (idx + 1) % acts.length;
        setActivityText(acts[idx]);
        setActivityOpacity(1);
      }, 500);
    }, 3800);

    return () => {
      clearInterval(countInterval);
      clearInterval(tickerInterval);
    };
  }, []);

  // ═══════════════════════════════════════
  // 3D TILT EFFECT
  // ═══════════════════════════════════════
  useEffect(() => {
    if (isMobile || !panelRef.current) return;
    const p = panelRef.current;
    const handleMove = (e) => {
      const r = p.getBoundingClientRect();
      const rx = (e.clientY - (r.top + r.height / 2)) / window.innerHeight * 1.8;
      const ry = (e.clientX - (r.left + r.width / 2)) / window.innerWidth * -1.4;
      p.style.transform = `perspective(1400px) rotateX(${rx}deg) rotateY(${ry}deg)`;
    };
    document.addEventListener("mousemove", handleMove);
    return () => document.removeEventListener("mousemove", handleMove);
  }, [isMobile]);

  // Existing Authentication Logic...
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,500;0,600;0,700;1,600&family=Sora:wght@300;400;500;600;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    return () => { };
  }, []);

  // Auto-redirect if already logged in
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate(`/${RouteUrls.dashboard}`, { replace: true });
    }
  }, [navigate]);

  const startTimer = () => {
    setTimer(30);
    if (timerInterval.current) clearInterval(timerInterval.current);
    timerInterval.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerInterval.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (timerInterval.current) clearInterval(timerInterval.current);
    };
  }, []);

  const parseAndStoreRedirectData = () => {
    const redirectParam = searchParams.get("redirect");
    if (!redirectParam) return;
    try {
      const decodedRedirect = decodeURIComponent(redirectParam);
      const queryPart = decodedRedirect.split("?")[1];
      if (queryPart) {
        const params = new URLSearchParams(queryPart);
        const encodedOrder = params.get("data") || params.get("order");
        if (encodedOrder) {
          const decodedData = JSON.parse(decodeURIComponent(encodedOrder));
          localStorage.setItem("selectedData", JSON.stringify(decodedData));
        }
      }
    } catch (error) {
      console.error("Error parsing redirect data:", error);
    }
  };

  useEffect(() => {
    parseAndStoreRedirectData();
  }, [searchParams]);

  useEffect(() => {
    const emailParam = searchParams.get("email");
    const pwdParam = searchParams.get("pwd");
    if (emailParam || pwdParam) {
      setLoginMethod("password");
      setFormData(prev => {
        return prev.map(field => {
          if (field.id === "email" && emailParam) {
            return { ...field, value: emailParam };
          }
          if (field.id === "password" && pwdParam) {
            return { ...field, value: pwdParam };
          }
          return field;
        });
      });
    }
  }, [searchParams]);

  const finalizeLogin = (data) => {
    const myInfoData = FormateMyInfoData(data);
    dispatch(setMyInfo(myInfoData));
    localStorage.setItem("token", data?.token);
    if (data?.refreshToken) {
      localStorage.setItem("refreshToken", data?.refreshToken);
    } else {
      localStorage.removeItem("refreshToken");
    }
    localStorage.setItem("x-nlp-userid", myInfoData?.id);
    dispatch(stopLoading());
    redirectAfterLogin();
  };

  const redirectAfterLogin = () => {
    const redirectParam = searchParams.get("redirect");
    let redirectUrl = `/${RouteUrls.dashboard}`;
    const storedData = localStorage.getItem("selectedData");
    try {
      if (storedData) {
        const decodedData = JSON.parse(storedData);
        if (decodedData.isSubscription === true && decodedData.redirectUrl) {
          localStorage.removeItem("selectedData");
          window.location.href = decodedData.redirectUrl;
          return;
        }
      }
      if (redirectParam) redirectUrl = decodeURIComponent(redirectParam);
      localStorage.removeItem("selectedData");
      navigate(redirectUrl, { replace: true });
    } catch (error) {
      localStorage.removeItem("selectedData");
      navigate(`/${RouteUrls.dashboard}`, { replace: true });
    }
  };

  const handleLoginMethodChange = (method) => {
    if (method !== "otp") {
      setOtpSent(false);
      setTimer(0);
      if (timerInterval.current) clearInterval(timerInterval.current);
    }
    setLoginMethod(method);
    setFormData(
      method === "otp"
        ? JSON.parse(JSON.stringify(OtpMethodDataArr))
        : JSON.parse(JSON.stringify(PasswordMethodDataArr))
    );
  };

  const validateMobile = (mobile) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(mobile);
  };

  const handleSendOTP = async () => {
    const mobileValue = formData[0].value;
    if (!mobileValue) {
      dispatch(setAlertData({ alertMessage: "Mobile number is required", alertVariant: "error", openAlert: true }));
      return;
    }
    if (!validateMobile(mobileValue)) {
      dispatch(setAlertData({ alertMessage: "Please enter a valid 10-digit mobile number", alertVariant: "error", openAlert: true }));
      return;
    }
    dispatch(startLoading({ loading: true, loadtext: "Sending OTP..." }));
    const res = await authApi.mobileSendOtp({
      mobileNumber: mobileValue,
      requestType: "login",
    });
    dispatch(stopLoading());
    if (res?.success) {
      setOtpSent(true);
      startTimer();
      setFormData((prev) =>
        prev.map((el) => (el.id === "otp" ? { ...el, readOnly: false } : el))
      );
    }
  };

  const handleVerifyOtp = async () => {
    if (otpValue.length !== 4) {
      dispatch(setAlertData({ alertMessage: "Please enter a valid 4-digit OTP", alertVariant: "error", openAlert: true }));
      return;
    }
    dispatch(startLoading({ loading: true, loadtext: "Verifying OTP..." }));
    const mobileNumber = is2FA ? tempUserData?.phone : formData?.[0]?.value;
    const res = await authApi.verifyOtp({
      mobileNumber: mobileNumber,
      email: null,
      otp: otpValue,
    });
    if (res?.success) {
      dispatch(stopLoading());
      dispatch(setAlertData({ alertMessage: "Otp Verified Successfully", alertVariant: "success", openAlert: true }));
      finalizeLogin(res.data);
    } else {
      dispatch(stopLoading());
    }
  };

  const handlePasswordVerification = async () => {
    if (!formData[0].value || !formData[1].value) {
      dispatch(setAlertData({ alertMessage: "Email and Password are required", alertVariant: "error", openAlert: true }));
      return;
    }
    dispatch(startLoading({ loading: true, loadtext: "Signing In..." }));
    
    const username = formData[0].value.includes('@') 
      ? formData[0].value 
      : formData[0].value.replace(/[^\d+]/g, '');

    const res = await authApi.signIn({
      username: username,
      password: formData[1].value,
    });
    if (res?.success) {
      const myInfoData = FormateMyInfoData(res?.data);
      const role = myInfoData?.userType?.toUpperCase();
      if (role === "CORPORATEUSER" || role === "PROFESSIONAL") {
        const otpRes = await authApi.mobileSendOtp({
          mobileNumber: res?.data?.phone,
          requestType: "login",
        });
        if (otpRes?.success) {
          dispatch(stopLoading());
          setTempUserData(res.data);
          const phone = res?.data?.phone || "";
          setMaskedPhone(`XXXXXX${phone.slice(-4)}`);
          setIs2FA(true);
          setOtpSent(true);
          setOtpValue("");
          startTimer();
        }
      } else {
        finalizeLogin(res.data);
      }
    } else {
      dispatch(stopLoading());
    }
  };

  const handleSignIn = async () => {
    if (loading) return;
    setLoading(true);
    try {
      if (loginMethod === "otp") {
        if (!otpSent) await handleSendOTP();
        else await handleVerifyOtp();
      } else {
        await handlePasswordVerification();
      }
    } catch (error) {
      console.error("Sign in error:", error);
      dispatch(stopLoading());
      dispatch(setAlertData({ alertMessage: "Sign in failed. Please try again.", alertVariant: "error", openAlert: true }));
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (timer > 0) return;
    const mobileNumber = is2FA ? tempUserData?.phone : formData?.[0]?.value;
    const res = await authApi.mobileSendOtp({
      mobileNumber: mobileNumber,
      requestType: "login",
    });
    if (res?.success) {
      startTimer();
      dispatch(setAlertData({ alertMessage: "OTP Resent Successfully", alertVariant: "success", openAlert: true }));
    }
  };

  const handleInputChange = (id, val) => {
    setFormData((prev) => prev.map((f) => (f.id === id ? { ...f, value: val } : f)));
  };

  // ═══════════════════════════════════════
  // SERVICE ROW DEFINITIONS
  // ═══════════════════════════════════════
  const rowDefs = [
    {
      dir: 'left', speed: 32,
      items: [
        { name: 'Legal Notice', hot: false, col: 'rgba(232,101,26,.18)', str: '#F0905A', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>' },
        { name: 'Contract Drafting', hot: true, col: 'rgba(240,180,41,.18)', str: '#F0B429', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>' },
        { name: 'Talk to Lawyer', hot: false, col: 'rgba(27,58,107,.32)', str: '#7AADFF', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>' },
        { name: 'Legal Review', hot: false, col: 'rgba(13,148,136,.22)', str: '#2DD4BF', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>' },
        { name: 'ODR Mediation', hot: true, col: 'rgba(139,43,95,.25)', str: '#E8A0D0', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>' },
        { name: 'Legal Consultation', hot: false, col: 'rgba(15,157,88,.18)', str: '#5FE3A1', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>' },
        { name: 'File a Case', hot: false, col: 'rgba(192,57,43,.2)', str: '#F08080', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"/>' },
        { name: 'Litigation Funding', hot: false, col: 'rgba(240,180,41,.15)', str: '#F0B429', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>' },
      ]
    },
    {
      dir: 'right', speed: 26,
      items: [
        { name: 'ITR Filing', hot: true, col: 'rgba(15,157,88,.2)', str: '#5FE3A1', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M15 15h.01M5 20h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v13a2 2 0 002 2z"/>' },
        { name: 'GST Return', hot: false, col: 'rgba(240,180,41,.18)', str: '#F0B429', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5"/>' },
        { name: 'GST Registration', hot: false, col: 'rgba(27,58,107,.3)', str: '#7AADFF', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4z"/>' },
        { name: 'TDS Return', hot: false, col: 'rgba(232,101,26,.18)', str: '#F0905A', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z"/>' },
        { name: 'Annual Accounts', hot: false, col: 'rgba(13,148,136,.2)', str: '#2DD4BF', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>' },
        { name: 'Due Diligence', hot: true, col: 'rgba(139,43,95,.22)', str: '#E8A0D0', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>' },
        { name: 'Financial Advisory', hot: false, col: 'rgba(15,157,88,.16)', str: '#5FE3A1', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>' },
        { name: 'Audit Services', hot: false, col: 'rgba(240,180,41,.14)', str: '#F0B429', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>' },
      ]
    },
    {
      dir: 'left', speed: 22,
      items: [
        { name: 'Pvt Ltd Registration', hot: true, col: 'rgba(27,58,107,.32)', str: '#7AADFF', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>' },
        { name: 'Trademark Filing', hot: false, col: 'rgba(232,101,26,.18)', str: '#F0905A', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z"/>' },
        { name: 'Patent Filing', hot: false, col: 'rgba(240,180,41,.16)', str: '#F0B429', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>' },
        { name: 'Secretarial Audit', hot: false, col: 'rgba(139,43,95,.22)', str: '#E8A0D0', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>' },
        { name: 'DPDP Compliance', hot: true, col: 'rgba(15,157,88,.18)', str: '#5FE3A1', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>' },
        { name: 'Copyright Filing', hot: false, col: 'rgba(27,58,107,.28)', str: '#7AADFF', ic: '<circle cx="12" cy="12" r="10"/><path stroke-linecap="round" stroke-linejoin="round" d="M14.5 9A4 4 0 108 13.5"/>' },
        { name: 'POSH Compliance', hot: false, col: 'rgba(192,57,43,.18)', str: '#F08080', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>' },
        { name: 'LLP Registration', hot: false, col: 'rgba(13,148,136,.2)', str: '#2DD4BF', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>' },
      ]
    },
    {
      dir: 'right', speed: 18,
      items: [
        { name: 'NRI Help Desk', hot: false, col: 'rgba(240,180,41,.16)', str: '#F0B429', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>' },
        { name: 'Virtual Legal Counsel', hot: true, col: 'rgba(27,58,107,.3)', str: '#7AADFF', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>' },
        { name: 'Fund Raising', hot: false, col: 'rgba(15,157,88,.18)', str: '#5FE3A1', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>' },
        { name: 'Startup Toolkit', hot: false, col: 'rgba(232,101,26,.18)', str: '#F0905A', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"/>' },
        { name: 'Consumer Complaint', hot: false, col: 'rgba(139,43,95,.22)', str: '#E8A0D0', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>' },
        { name: 'NGO Registration', hot: false, col: 'rgba(15,157,88,.16)', str: '#5FE3A1', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>' },
        { name: 'Pitch Deck', hot: false, col: 'rgba(240,180,41,.14)', str: '#F0B429', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"/>' },
        { name: 'RTI Application', hot: false, col: 'rgba(27,58,107,.28)', str: '#7AADFF', ic: '<path stroke-linecap="round" stroke-linejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>' },
      ]
    }
  ];

  const renderLeftPanel = () => (
    <div className="world">
      <canvas id="net-canvas" ref={canvasRef}></canvas>
      <div className="a1"></div>
      <div className="a2"></div>
      <div className="a3"></div>
      <div className="grain"></div>

      <div className="world-header">
        <div className="platform-pill">
          <div className="pill-dot"></div>
          <span className="pill-txt">Global Legal Network</span>
        </div>
        <h1 className="world-headline" id="typed-line" style={{ height: '2.2em' }}>
          {typedHeadline.split('\n').map((line, i) => (
            <Fragment key={i}>
              {line}<br />
            </Fragment>
          ))}
          <span className="cursor">|</span>
        </h1>
      </div>

      <div className="rows-stage" id="rowsStage">
        {rowDefs.map((rd, ridx) => (
          <div
            key={ridx}
            className="row"
            style={{
              animation: `${rd.dir === 'left' ? 'sl' : 'sr'} ${rd.speed}s linear infinite`,
              animationPlayState: 'running'
            }}
            onMouseEnter={(e) => e.currentTarget.style.animationPlayState = 'paused'}
            onMouseLeave={(e) => e.currentTarget.style.animationPlayState = 'running'}
          >
            {[...rd.items, ...rd.items].map((it, i) => (
              <div key={i} className={`svc ${it.hot ? 'hot' : ''}`}>
                <div className="svc-icon" style={{ background: it.col }}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke={it.str} strokeWidth="1.65" dangerouslySetInnerHTML={{ __html: it.ic }} />
                </div>
                <span className="svc-name">{it.name}</span>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className="live-badge">
        <div className="live-pulse"></div>
        <span className="live-txt">Live Practitioners: <span className="live-count">{liveCount}</span></span>
      </div>

      <div className="activity-ticker">
        <div className="activity-dot"></div>
        <span className="activity-text" style={{ opacity: activityOpacity }}>{activityText}</span>
      </div>

      <div className="world-footer">
        <p className="tagline">Providing <em>Expert</em> solutions for every <em>Legal</em> challenge.</p>
      </div>
    </div>
  );

  return (
    <div className="login-container">
      {!isMobile && renderLeftPanel()}

      <div className="panel" ref={panelRef}>
        <div className="form-wrap">
          <div className="logo-block">
            <img
              src="https://nolegalpaisa.com/assets/images/new_logo.webp"
              alt="NoLegalPaisa"
              onClick={() => window.location.href = "/home.html"}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <h2 className="heading">
            {is2FA ? "Secure Verification" : (otpSent ? "Verify OTP" : "Welcome Back")}
          </h2>
          <p className="subheading">
            {is2FA ? "Identity verification required for your account." : (otpSent ? `Enter the 4-digit code sent to +91 ${formData[0].value}` : "Access your dashboard.")}
          </p>

          <div style={{ margin: "20px 0" }}>
            {is2FA ? (
              <Fragment>
                <div className="field">
                  <label className="field-lbl">Enter Verification Code</label>
                  <OtpInput
                    length={4}
                    value={otpValue}
                    onChange={setOtpValue}
                    onComplete={() => { }}
                  />
                </div>
                <div className="meta">
                  <button className="link-btn link-otp" disabled={timer > 0} onClick={handleResend}>
                    {timer > 0 ? `Resend in ${timer}s` : "Resend code"}
                  </button>
                </div>
                <button className="cta ok" onClick={handleVerifyOtp}>Confirm & Continue</button>
              </Fragment>
            ) : (
              <Fragment>
                {otpSent && loginMethod === "otp" ? (
                  <Fragment>
                    <div className="field">
                      <label className="field-lbl">Verification Code</label>
                      <OtpInput
                        length={4}
                        value={otpValue}
                        onChange={setOtpValue}
                        onComplete={() => { }}
                      />
                    </div>
                    <div className="meta">
                      <button className="link-btn link-otp" onClick={() => { setOtpSent(false); setOtpValue(""); }}>Change Number</button>
                      <button className="link-btn link-otp" disabled={timer > 0} onClick={handleResend}>
                        {timer > 0 ? `Resend in ${timer}s` : "Resend OTP"}
                      </button>
                    </div>
                  </Fragment>
                ) : (
                  formData.map((f) => {
                    if (loginMethod === "otp" && f.id === "otp") return null;
                    return (
                      <div className="field" key={f.id}>
                        <label className="field-lbl">{f.label}</label>
                        <div className={f.type === "password" ? "pw" : ""}>
                          <input
                            type={f.type === "password" && showPassword ? "text" : f.type}
                            className="field-inp"
                            placeholder={f.placeholder}
                            value={f.value || ""}
                            onChange={(e) => handleInputChange(f.id, e.target.value)}
                            onKeyPress={(e) => e.key === "Enter" && handleSignIn()}
                          />
                          {f.type === "password" && (
                            <button className="eye-btn" onClick={() => setShowPassword(!showPassword)}>
                              {showPassword ? (
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18" /></svg>
                              ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                              )}
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })
                )}

                <div className="meta">
                  {!otpSent && (
                    <button className="link-btn link-otp" onClick={() => handleLoginMethodChange(loginMethod === "otp" ? "password" : "otp")}>
                      {loginMethod === "otp" ? "Use Password" : "Login with OTP"}
                    </button>
                  )}
                  {loginMethod === "password" && (
                    <button className="link-btn link-forgot" onClick={() => navigate(`/${RouteUrls.forgot}`)}>Forgot Password?</button>
                  )}
                </div>

                <button className="cta" onClick={handleSignIn} disabled={loading}>
                  {loading ? "Processing..." : (loginMethod === "otp" ? (otpSent ? "Verify & Login" : "Send OTP") : "Sign In to Account")}
                </button>
              </Fragment>
            )}

            {!is2FA && (
              <Fragment>
                <div className="divider">
                  <div className="div-line"></div>
                  <span className="div-txt">New to platform?</span>
                  <div className="div-line"></div>
                </div>

                <p className="reg-lbl">Select Account Type</p>
                <div className="tabs">
                  {[
                    { label: "Individual", url: RouteUrls.register, icon: <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg> },
                    { label: "Corporate", url: `${RouteUrls.register}/${RouteUrls.corporate}`, icon: <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg> },
                    { label: "NRI", url: `${RouteUrls.register}/${RouteUrls.NriSignup}`, icon: <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> },
                    { label: "Professional", url: `${RouteUrls.register}/${RouteUrls.professional}`, icon: <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg> },
                  ].map((t) => (
                    <div className="tab" key={t.label} onClick={() => navigate(`/${t.url}`)}>
                      {t.icon}
                      <span>{t.label}</span>
                    </div>
                  ))}
                </div>
              </Fragment>
            )}

            <div className="footer-modern">
              <Link href="/home.html" className="back-home">
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
                Back to Homepage
              </Link>
              <div className="policy">
                <a href="#">Privacy Policy</a>
                <span className="dot">•</span>
                <a href="#">Terms of Service</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;